import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

export function KPICard({
  title,
  value,
  change,
  changeLabel,
  icon: Icon,
  loading = false,
  className,
}) {
  if (loading) {
    return (
      <Card className={className}>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-4 rounded" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-8 w-32 mb-1" />
          <Skeleton className="h-3 w-20" />
        </CardContent>
      </Card>
    );
  }

  const getTrendIcon = () => {
    if (change > 0) return <TrendingUp className="h-3 w-3" />;
    if (change < 0) return <TrendingDown className="h-3 w-3" />;
    return <Minus className="h-3 w-3" />;
  };

  const getTrendColor = () => {
    if (change > 0) return 'text-[hsl(var(--success))]';
    if (change < 0) return 'text-[hsl(var(--destructive))]';
    return 'text-muted-foreground';
  };

  return (
    <Card className={cn('card-hover', className)} data-testid="kpi-card">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold" data-testid="kpi-value">
          {value}
        </div>
        {(change !== undefined || changeLabel) && (
          <div className={cn('flex items-center gap-1 text-xs mt-1', getTrendColor())}>
            {change !== undefined && getTrendIcon()}
            <span data-testid="kpi-change">
              {change !== undefined && (
                <>{change > 0 ? '+' : ''}{typeof change === 'number' ? change.toFixed(1) : change}%</>
              )}
              {changeLabel && <span className="text-muted-foreground ml-1">{changeLabel}</span>}
            </span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

export default KPICard;
